import { render, staticRenderFns } from "./table-methodological-info.component.vue?vue&type=template&id=621f653d"
import script from "./table-methodological-info.component.vue?vue&type=script&lang=ts"
export * from "./table-methodological-info.component.vue?vue&type=script&lang=ts"
import style0 from "./table-methodological-info.component.vue?vue&type=style&index=0&id=621f653d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports